/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Task/view.blocks to change it.
import AutomationTask from 'DesignSystem/AutomationTask/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Task({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/EventActions/Content/Action/Task"
  
}) {
  return (<React.Fragment
>
<AutomationTask
  viewPath={`${viewPath}/AutomationTask`}
/>
{children}
</React.Fragment>)
}